import React from 'react';
import {FormattedMessage} from 'react-intl';

export default function ({children, required, title}) {
    return <label className={'text-muted mb-0'}>{title && <FormattedMessage id={title}/>}{children} {required &&
    <span className={"text-danger"}>*</span>}</label>;
}
